import React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import { Permission } from '../../api/roles.dao';
import { hasPermission } from '../../infrastructure/utils/has-permissions';
import './restricted-content.scss';
import { Container } from 'typescript-ioc';
import { IRouter } from '../../infrastructure/router';
import { Routes } from '../../routes-table';


interface IProps {
    intl: IntlShape;
    content?: JSX.Element;
    permission?: Permission;
    children?: JSX.Element;
}

const RestrictedContent = mobxReact.observer(injectIntl(({intl, permission, content, children}: IProps) => {
    const isPermission = hasPermission(permission);
    const redirectEventPermissions = [
        Permission.SCHEDULE_TAB,
        Permission.PASSPORT_TAB,
        Permission.CONNECTIONS_MANAGEMENT,
        Permission.REPORTS_TAB,
        Permission.ASSETS_TAB,
        Permission.ARTIFACTS_TAB,
    ];

    if (!isPermission && redirectEventPermissions.includes(permission)) {
        const routingService = Container.get(IRouter);
        const { params } = routingService.router.getState();
        routingService.navigate(Routes.OrganizationsList, { accountId: params.accountId, eventId: params.eventId });
    }

    return isPermission ? content : (
        <>
            {children}
            <div className='restricted-content'>{
                intl.formatMessage(
                    {
                        id: 'oe.api.accessIsDenied',
                        description: 'Access is denied message',
                        defaultMessage: 'Access Denied. If you need help please contact your account manager or contact product support.',
                    }
                )}
                <br/>
                <span className='restricted-content-contact-block'>If you need help please contact your account manager or contact<a href="mailto:internalproductsupport@openexc.com"> product support</a>
                </span>
            </div>
        </>
    );
}));

export { RestrictedContent, IProps };